import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const PingHaug = HelpVideo(
    'Pings',
    'Editor / Gestures',
    'The Ping Gesture',
    35010,
    'https://s.metroretro.io/app/haug/35010-pings.mp4'
);
